export default "__VITE_ASSET__v06Fw1iG__"